import React from 'react';

export function DashboardDetail(props) {

	let role = (
		props.type == 'phone' || 
		props.type == 'url' ||
		props.link
	) ? 'button' : null;
	
	let onclick = (props.type == 'phone')
		? 	() => window.location.href='tel:' + props.value?.replace(/\D/g, "")
		:	(props.type == 'url') 
			? 	() => window.open(props.value?.replace(/^(https?:\/\/)?/i, (a)=>a || 'http://'))
			:	(props.link)
				? 	() => window.location.href = props.link
				: 	null;

	return (

		<>
			{ props.value && 
				<div className="details-row" role={ role } onClick={ onclick }>
					<div className="details-field">{ props.field}:</div>
					<div className="details-gap"></div>
					<div className="details-value">{props.value}
						{ props.type == 'phone' &&
							<span style={{ float: 'right' }}><i className="text-muted fas fa-phone"></i></span>
						}
						{ props.type == 'url' &&
							<span style={{ float: 'right' }}><i className="text-muted fas fa-external-link-alt"></i></span>
						}
						{ props.link &&
							<span style={{ float: 'right' }}><i className="text-muted fas fa-arrow-alt-circle-right"></i></span>
						}
					</div>
				</div>
			}
		</>
	);
}
